import { defineComponent as _defineComponent } from 'vue'
import ClickMenu from '@/components/menu/ClickMenu.vue';
import { useI18n } from '@/composables/i18n';
import { DashboardLayout } from '@/models/Charts/dashboardDefinition';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutDropdown',
  props: {
    value: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: Array<number | string> | number | string) => void), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: DashboardLayout;
};





const { t } = useI18n();

const selectedValue = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const names = computed<string[]>(() => ids.value.map(() => ''));

const ids = computed<number[]>(
  () =>
    Object.keys(DashboardLayout)
      .filter((x) => !isNaN(Number(x)))
      .map((x) => Number(x))
      .slice(0, itemIcons.value.length),
  // The slice hides the two new layouts, which don't have an icon
);

const itemIcons = computed<string[]>(() => [
  '1x1',
  '1x2',
  '2x2',
  '2x3',
  'bc-overview-like',
  'inverse-bc-overview-like',
  '2x1',
  '2x3-merge-top-right',
  '2x3-merge-top-left',
  '2x3-merge-bottom-right',
  '2x3-merge-right',
  '2x3-merge-left',
  '2x3-two-double-two-single',
]);

return { __sfc: true,props, emit, t, selectedValue, names, ids, itemIcons, ClickMenu }
}

})